import React from "react";

function Clinical_report() {

    return (

        <div style={{ textAlign: "center", marginTop: "120px", color: "#555" }}>
            <h2>📄 Documents Pending</h2>
            <p style={{ fontSize: "16px", marginTop: "10px" }}>
                Some required documents are still pending from your side.
            </p>
            <p style={{ fontSize: "14px", color: "#888" }}>
                Please provide Clinical report documents to continue working with the Clinical report       </p>
        </div>
    );
}

export default Clinical_report